/**
 * FIXES2 item 8 — failures are inline and never fade. Opened as its own
 * <tr> directly under the failing row (Table.jsx's rowExtra), not a toast.
 */
import React from "react";
import Icon from "../../theme/untitled/icons/Icon";
import Button from "../../theme/untitled/Button/Button";
import styles from "./Table.module.scss";

const RowErrorStrip = ({ domain, message, onRetry, onDismiss, colSpan }) => (
  <tr>
    <td colSpan={colSpan} className={styles.errorCell}>
      <div className={styles.errorStrip}>
        <Icon name="AlertTriangle" className={styles.errorStripIcon} />
        <span className={styles.errorStripText}>
          <span className={styles.errorStripName}>{domain.domain}</span> couldn&rsquo;t be
          {domain.available ? " paused" : " resumed"}: {message}. It is still{" "}
          {domain.available ? "active" : "paused"}.
        </span>
        <span className={styles.errorStripActions}>
          <Button hierarchy="tertiary" size="sm" onClick={onRetry}>
            Try again
          </Button>
          <Button hierarchy="tertiary" size="sm" onClick={onDismiss}>
            Dismiss
          </Button>
        </span>
      </div>
    </td>
  </tr>
);

export default RowErrorStrip;
